<!-- Content -->
<div class="mb-2 question-title-container">
  <div class="question-title">
    {{ translate.instant('question') }} {{ index !== null ? (index + 1) : '' }}
    <i class="fa fa-check" *ngIf="checkedAndCorrect"></i>
  </div>
  <small>{{ 'question_type' | translate }} {{ questionType | translate }}</small>
</div>